import { render } from "./FormUpload.vue?vue&type=template&id=022aa09f"
import script from "./FormUpload.vue?vue&type=script&lang=js"
export * from "./FormUpload.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/Form/FormUpload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "022aa09f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('022aa09f', __exports__)) {
    console.log('reload')
    api.reload('022aa09f', __exports__)
  }
  
  module.hot.accept("./FormUpload.vue?vue&type=template&id=022aa09f", () => {
    console.log('re-render')
    api.rerender('022aa09f', render)
  })

}


export default __exports__